module.exports = __webpack_public_path__ + "img/step3.7b466c70.svg";